import Image from "next/image";
import Link from "next/link";
import posthog from "posthog-js";

export interface InlineCTAProps {
	buttonText?: string;
	description?: string;
	thumbnail?: {
		url: string;
		alt?: string;
	};
	title: string;
	url: string;
}

const InlineCTA = ({
	title,
	description,
	thumbnail,
	url,
	buttonText,
}: InlineCTAProps) => {
	return (
		<div className="flex h-full w-full flex-col justify-between gap-6 rounded-xl border bg-white p-6 sm:flex-row sm:items-center dark:bg-slate-800">
			<div className="flex flex-1 flex-col gap-2">
				<h3 className="font-semibold text-2xl text-slate-900 dark:text-white">
					{title}
				</h3>
				{description && (
					<p className="text-slate-600 dark:text-slate-300">{description}</p>
				)}

				{url && (
					<div className="mt-4">
						<Link
							href={url}
							onClick={() => posthog.capture("cta:inline_clicked")}
							className="animated-background inline-flex w-full items-center justify-center rounded-full bg-linear-to-r from-sky-500 via-sky-700 to-sky-500 px-6 py-2.5 font-medium text-white! shadow-md transition-all hover:scale-105 hover:from-sky-600 hover:via-sky-800 hover:to-sky-600 md:w-auto"
						>
							{buttonText || "Learn More"}
						</Link>
					</div>
				)}
			</div>

			{thumbnail?.url && (
				<div className="relative aspect-video w-full shrink-0 overflow-hidden rounded-lg sm:aspect-square sm:w-48">
					<Image
						src={thumbnail.url}
						alt={thumbnail.alt || title}
						fill
						className="object-cover"
					/>
				</div>
			)}
		</div>
	);
};

export default InlineCTA;
